import {brandConfigObjectMap} from "@/brand/brandConfig";

export const brandConfigMap = new Map();

brandConfigMap.set('http://localhost:8080', getBrandConfig('tlk-za-en'));
brandConfigMap.set('https://melodymadness.co.za', getBrandConfig('tlk-za-en'));

export function getBrandConfig(brand) {
    const brandConfigObject = brandConfigObjectMap.get(brand);
    return {
        brand,
        gameTitle: brandConfigObject.gameTitle,
        freePlayServiceId: brandConfigObject.freePlayServiceId,
        newIntegration: brandConfigObject.newIntegration,
        baseRoute: brandConfigObject.baseRoute,
        isMelodyMadness: brandConfigObject.isMelodyMadness,
    }
}
